import { BibleBook } from '@nucleus/bible';
import { PlaylistWeb } from '@nucleus/types/web/sermons/playlist';
import { SermonTagWeb } from '@nucleus/types/web/sermons/sermon-tag';
import { SpeakerWeb } from '@nucleus/types/web/sermons/speaker';
import { useUser } from '@nucleus/web-theme';
import { UseSuspenseQueryResult, useSuspenseQuery } from '@tanstack/react-query';
import { queryCollection } from '../queries/collection';

type Collection = PlaylistWeb | SermonTagWeb | SpeakerWeb | BibleBook;

type QueryResult = Awaited<ReturnType<typeof queryCollection<Collection | undefined>>>;

export const useCollection = (
  engineId: string | undefined,
  collectionType?: 'playlists' | 'tags' | 'speakers' | 'books',
  slugOrId?: string
): UseSuspenseQueryResult<QueryResult> => {
  const { currentUser, jwtToken } = useUser();

  return useSuspenseQuery({
    queryKey: ['sermonHub', collectionType, slugOrId, currentUser?.id],
    queryFn: async () => {
      if (collectionType === undefined || slugOrId === undefined) {
        return { collection: undefined };
      }
      return await queryCollection(engineId, collectionType, slugOrId, jwtToken);
    },
  });
};
